import { render, staticRenderFns } from "./ProfessionsItem.vue?vue&type=template&id=6a72fdfc&scoped=true"
import script from "./ProfessionsItem.vue?vue&type=script&lang=ts"
export * from "./ProfessionsItem.vue?vue&type=script&lang=ts"
import style0 from "./ProfessionsItem.vue?vue&type=style&index=0&id=6a72fdfc&prod&scoped=true&lang=css"
import style1 from "./ProfessionsItem.vue?vue&type=style&index=1&id=6a72fdfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72fdfc",
  null
  
)

export default component.exports